import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { newsArticles } from "@/mocks/news";

export default function PlotAnalysis() {
  const articles = newsArticles.filter((item) => item.category === "评论").slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="STORY INSIGHT"
        title="热门剧情解析"
        desc="从叙事结构到人物动机，我们整理了最受关注的剧情解读与深度评论。"
        moreHref="/news"
        moreLabel="查看更多解析"
      />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {articles.map((article, i) => (
          <Link
            key={article.id}
            to={`/news/${article.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300 cursor-pointer"
          >
            <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
              <img
                src={article.cover}
                alt={article.title}
                title={article.title}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 font-label text-sm text-primary-950">
                0{i + 1}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{article.category}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {article.publishedAt}
                </span>
              </div>
              <h3 className="mt-3 line-clamp-2 text-base font-medium leading-snug text-foreground-950 transition-colors group-hover:text-accent-700">
                {article.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">{article.summary}</p>
              <span className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-600">
                进入详情
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}